export const media = {
  fileId: null,
  metaDataUrl: null,
  downloadUrl:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
};
